import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import "./home.js";
import "./tab.js";
import "./contact.js";
import 'lity';

jQuery(function ($) {

  // smooth scroll
  var headerHeight = $('.header__wrap').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function() {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }
  $('a[href^="#"]').not('.channel__top').click(function() {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
    return false;
  });

	// nav
	$(function () {
		var dropdownList = $('.js-nav .js-navList');
		var dropdown = $('.js-nav .js-navList .js-navItem');
		var dropdownItem = $('.js-nav .js-navList .js-navItem .js-navContents');
		var toggleClickA = $('.js-nav .js-navSp .js-navSp-item');
		if (matchMedia('(max-width: 767px)').matches) {
			toggleClickA.on('click', function () {
				$(this).toggleClass('is_close');
				dropdownList.toggleClass('is_close');
			});
			dropdown.on('click', function () {
				if ($(this).hasClass('is_close')) {
					$(this).removeClass('is_close');
					$(this).find('.js-navContents').removeClass('is_close');
				} else {
					dropdown.removeClass('close');
					dropdown.find('.js-navContents').removeClass('is_close');
					$(this).addClass('is_close');
					$(this).find('.js-navContents').addClass('is_close');
				}
			});
		} else {
			dropdownItem.removeClass('open');
			dropdown.on({
				'mouseenter': function () {
					$(this).addClass('open');
					$(this).find('.js-navContents').addClass('open');
					// dropdownItem.fadeIn();
				},
				'mouseleave': function () {
					dropdown.removeClass('open');
					dropdownItem.removeClass('open');
					// dropdownItem.fadeOut();
				}
			});
		}

		$('.nav-spList-item.ico-loupe').on('click', function () {
			$('.nav-searchBox').slideToggle();
			$(this).toggleClass('is_close');
		});
	});

	// scroll animation
	$(window).scroll(function () {
		$('.js-fadeUp, .js-merit-anime').each(function () {
			var targetElement = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
				if (scroll > targetElement - windowHeight + 100){
					$(this).addClass('scrollin');
			}
			// else {
			// 	$(this).removeClass('scrollin');
			// }
		});
	});

});
